import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {EmailRendererComponent} from './renderer/email-renderer/email-renderer.component';
import {HtmlRendererComponent} from './renderer/html-renderer/html-renderer.component';
import {IframeRendererViewerComponent} from './renderer/renderer-viewer/iframe-renderer-viewer/iframe-renderer-viewer.component';
import {BlobRendererViewerService} from './renderer/renderer-viewer/blob-renderer-viewer/blob-renderer-viewer.service';
import {BlobRendererViewerComponent} from './renderer/renderer-viewer/blob-renderer-viewer/blob-renderer-viewer.component';
import {IconsModule} from '../icons/icons.module';
import {FormModule} from '../form/form.module';
import {EmailRendererClientsService} from './renderer/email-renderer/email-renderer-clients/email-renderer-clients.service';
import {EmailRendererTestService} from './renderer/email-renderer/email-renderer-tests/email-renderer-test/email-renderer-test.service';
import {EmailRendererTestResultsService} from './renderer/email-renderer/email-renderer-tests/email-renderer-test/email-renderer-test-results/email-renderer-test-results.service';
import {EmailRendererTestResultService} from './renderer/email-renderer/email-renderer-tests/email-renderer-test/email-renderer-test-results/email-renderer-test-result/email-renderer-test-result.service';
import {PipesModule} from '../pipes/pipes.module';

@NgModule({
    declarations: [
        BlobRendererViewerComponent,
        EmailRendererComponent,
        HtmlRendererComponent,
        IframeRendererViewerComponent,
    ],
    exports: [
        EmailRendererComponent,
        HtmlRendererComponent
    ],
    imports: [
        CommonModule,
        IconsModule,
        FormModule,
        PipesModule
    ],
    providers: [
        BlobRendererViewerService,
        EmailRendererClientsService,
        EmailRendererTestService,
        EmailRendererTestResultService,
        EmailRendererTestResultsService
    ]
})
export class RenderersModule {
}
